import './vehicle.css';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    CircularProgress,
    Box
} from '@mui/material';
import prevIcon from '../../assets/icons/left-arrow.svg';
import CancelIcon from '@mui/icons-material/Cancel';
import nextIcon from '../../assets/icons/right-arrow.svg';
import AddVehicle from './AddVehicle';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
var constants = require('../../constant');


const Vehicles = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [statusFilter, setStatusFilter] = useState('');
    const [vehicleTypeFilter, setVehicleTypeFilter] = useState('');
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddVehicle, setOpenAddVehicle] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities')) || [];
    const saveCityId = localStorage.getItem('saveCityId');
    const [openMapModal, setOpenMapModal] = useState(false);
    const [selectedMapVehicle, setSelectedMapVehicle] = useState(null);
    const [selectedVehicleId, setSelectedVehicleId] = useState("");
    const [mapLoading, setMapLoading] = useState(false);
    const clientId = localStorage.getItem('clientId');
    const vehicleSetEnabled = localStorage.getItem('vehicle_set_enabled');
    const [openSeatConfirmModal, setOpenSeatConfirmModal] = useState(false);
    const [pendingSeatConfirm, setPendingSeatConfirm] = useState(null);

    const [cityFilter, setCityFilter] = useState(() => {
        if (!Array.isArray(cities) || cities.length === 0) return null;

        const hasSavedCity = saveCityId && cities.some((city) => String(city.city_id) === String(saveCityId));

        if (hasSavedCity) return saveCityId;
        return cities[0].city_id;
    });

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const loadVehicles = async () => {
            const data = await fetchVehiclesData();
            setRows(data); // Set rows with fetched data
        };
        loadVehicles();
    }, [cityFilter]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'vehicleType') setVehicleTypeFilter(value);
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter) || Boolean(cityFilter) || Boolean(vehicleTypeFilter)
        );
    };

    const rideTypeCompatibility = {
        1: [1, 4],
        3: [3, 4],
        4: [1, 3, 4],
    };

    const applyOrResetFilter = () => {
        if (isFilterApplied) {
            setStatusFilter('');
            // setCityFilter('');
            setVehicleTypeFilter('');
            setIsFilterApplied(false);
            const resetVehicles = async () => {
                const data = await fetchVehiclesData();
                setRows(data);
            };
            resetVehicles();
        } else {
            const filteredRows = rows.filter((vehicle) =>
                (statusFilter ? vehicle.status === statusFilter : true) &&
                // (cityFilter ? vehicle.city === cityFilter : true) &&
                (vehicleTypeFilter ? vehicle.vehicleType === vehicleTypeFilter : true)
            );
            setRows(filteredRows);
        }
    };

    const getVehicleType = (type) => {
        return constants.VehicleTypes[type] || "Unknown";
    };

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const sortedAndPaginatedRows = rowArray.slice(
        currentPage * rowsPerPage,
        currentPage * rowsPerPage + rowsPerPage
    );

    const statusOptions = [
        { value: "Active", is_active: 1 },
        { value: "Inactive", is_active: 0 },
    ];

    const handleOpenAddVehicle = () => {
        setEditMode(false); // Set to "Add" mode
        setSelectedVehicle(null); // No pre-filled data
        setOpenAddVehicle(true);
    };

    const handleCloseAddVehicle = () => {
        setOpenAddVehicle(false);
        setSelectedVehicle(null);
    };

    const fetchVehiclesData = async () => {
        try {
            const cityId = cityFilter; // Safely access city_id
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/vehicle/get_client_vehicles`;
            const obj={
                token: token, city_id: cityId, timestamp: timestamp
            }

            const response =  await makeGetRequestToUrl(url, obj);

            // const response = await axios.get(serverUrl + `/vehicle/get_client_vehicles`, {
            //     params: { token, city_id: cityId },
            // });

            if(response.flag==102){
                 console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
            // Return the data or an empty array if data is missing
            return response.data || [];
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    const handleAddMapping = async () => {
        if (!selectedVehicleId) return;

        try {
            const existingIds = selectedMapVehicle.vehicle_set || [];

            const selectedVehicleData = rows.find(r => r.vehicle_id === selectedVehicleId);
            const currentVehicleData = rows.find(r => r.vehicle_id === selectedMapVehicle.vehicle_id);

            if (selectedVehicleData && currentVehicleData && 
                selectedVehicleData.seat_count < currentVehicleData.seat_count) {

                setPendingSeatConfirm({
                    message: `You are mapping requests for a higher-capacity vehicle having ${currentVehicleData.seat_count} seats to a lower-capacity vehicle having ${selectedVehicleData.seat_count} seats . 
                    This may impact customer expectations. Are you sure you want to proceed?`,
                    existingIds,
                    selectedVehicleId
                });
                setOpenSeatConfirmModal(true);
                return;
            }

            await performMapping(existingIds, selectedVehicleId);

        } catch (error) {
            console.error(error);
        }
    };

    const performMapping = async (existingIds, vehicleId) => {
        const updatedVehicleSet = [
            ...new Set([...existingIds, vehicleId])
        ];

        await makePostRequestToUrl(
            `${operationsUrl}/update_client_vehicle_type`,
            {
                token,
                client_id: clientId,
                vehicle_id: selectedMapVehicle.vehicle_id,
                vehicle_set: updatedVehicleSet,
            }
        );

        setSelectedMapVehicle(prev => ({
            ...prev,
            vehicle_set: updatedVehicleSet
        }));

        setRows(prevRows =>
            prevRows.map(r =>
                r.vehicle_id === selectedMapVehicle.vehicle_id
                    ? { ...r, vehicle_set: updatedVehicleSet }
                    : r
            )
        );

        setSelectedVehicleId("");
    };

    const handleSeatConfirm = (confirmed) => {
        setOpenSeatConfirmModal(false);
        
        if (confirmed && pendingSeatConfirm) {
            performMapping(pendingSeatConfirm.existingIds, pendingSeatConfirm.selectedVehicleId);
        }
        
        setPendingSeatConfirm(null);
    };

    const handleRemoveMapping = async (mappedId) => {
        try {
            const existingIds = selectedMapVehicle.vehicle_set || [];

            const updatedVehicleSet = existingIds.filter(
                id => id !== mappedId
            );

            await makePostRequestToUrl(
                `${operationsUrl}/update_client_vehicle_type`,
                {
                    token,
                    client_id: clientId,
                    vehicle_id: selectedMapVehicle.vehicle_id,
                    vehicle_set: updatedVehicleSet,
                }
            );

            // update modal state
            setSelectedMapVehicle(prev => ({
                ...prev,
                vehicle_set: updatedVehicleSet
            }));

            // update global rows
            setRows(prevRows =>
                prevRows.map(r =>
                    r.vehicle_id === selectedMapVehicle.vehicle_id
                        ? { ...r, vehicle_set: updatedVehicleSet }
                        : r
                )
            );

        } catch (error) {
            console.error(error);
        }
    };

    const handleViewDetails = async (row) => {

        const vehicleId = row.vehicle_id;

        try {

            const basicDetails = {
                vehicle_id: vehicleId,
                vehicle_name: row.vehicle_name,
                vehicle_type: row.vehicle_type,
                ride_type: row.ride_type,
                seat_count: row.seat_count,
                is_active: row.is_active,
                city_name: cities.filter(city => city.city_id === row.city_id)[0].city_name,
                display_order: row.display_order,
                vehicle_image: row.vehicle_image,
                convenience_charge: row.convenience_charge || '',
                min_driver_balance: row.min_driver_balance || '',
                commission_percentage: row.commission_percentage || '',
                commission_threshold: row.commission_threshold || '',
                fixed_commission: row.fixed_commission || '',
                request_radius_threshold: row.request_radius_threshold || '',
                initial_request_radius: row.initial_request_radius || '',
                request_radius_hop: row.request_radius_hop || '',
                // waiting_time_threshold: row.waiting_time_threshold || '',
                // waiting_charges: row.waiting_charges || '',
                batch_size:row.batch_size || '',
                request_accept_timer: row.request_accept_timer || '',
                tax_name: row.tax_name || '',
                tax_percentage: row.tax_percentage || '',
                convenience_driver_cut: row.convenience_driver_cut || '',
                platform_fee: row.platform_fee || '',
                delivery_commission_percentage: row.delivery_commission_percentage || '',
                delivery_commission_threshold: row.delivery_commission_threshold || '',
                delivery_fixed_commission: row.delivery_fixed_commission || '',
                delivery_convenience_charge: row.delivery_convenience_charge || '',
                delivery_convenience_driver_cut: row.delivery_convenience_driver_cut || '',
                delivery_platform_fee: row.delivery_platform_fee || '',
                delivery_tax_name: row.delivery_tax_name || '',
                delivery_tax_percentage: row.delivery_tax_percentage || ''
            };

            const timestamp = new Date().getTime();
            const url = `${serverUrl}/vehicle/get_details`;
            const obj={
                token: token, client_vehicle_id: vehicleId, timestamp: timestamp
            }

            const response =  await makeGetRequestToUrl(url, obj);

            // const response = await axios.get(serverUrl+`/vehicle/get_details`, {
            //     params: {
            //         token : token,
            //         client_vehicle_id: vehicleId
            //     }
            // });

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
            
            const vehicleDetails = {
                ...basicDetails,
                ...response.data, // Merge basic and additional details
            };

            setSelectedVehicle(vehicleDetails);
            setEditMode(true); 
            setOpenAddVehicle(true);
        } catch (error) {
            console.error('Error fetching vehicle details:', error);
        }
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                        Vehicle Type
                    </Typography>

                    <Grid container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                        {/* Filter controls */}
                        <Grid item>
                            <Select
                                value={cityFilter}
                                onChange={(e) => handleFilterChange('city', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_id} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item>
                            <Select
                                value={vehicleTypeFilter}
                                onChange={(e) => handleFilterChange('vehicleType', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: vehicleTypeFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Select Vehicle Type</MenuItem>
                                {Object.entries(constants.VehicleTypes).map(([id, label]) => (
                                    <MenuItem key={id} value={label}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item>
                            <Select
                                value={statusFilter}
                                onChange={(e) => handleFilterChange('status', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Status</MenuItem>
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                            </Select>
                        </Grid>
                        {/* <Grid item style={{ marginLeft: '4%' }}>
                            <Button
                                variant="contained"
                                onClick={applyOrResetFilter}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    marginRight: '1px',
                                    backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                            </Button>
                        </Grid> */}
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={handleOpenAddVehicle}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    backgroundColor: '#000000',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                + Add Vehicle
                            </Button>
                        </Grid>
                    </Grid>

                    {/* Vehicle Table */}
                    <TableContainer className="table-container" sx={{ maxHeight:'70vh'}}>
                        <Table stickyHeader className="scrollable-table" sx={{ minWidth: 1200 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" align="center" className="table-header" style={{ width: '5%' }}>
                                        <TableSortLabel
                                            active={orderBy === 'vehicle_id'}
                                            direction={orderBy === 'vehicle_id' ? order : 'asc'}
                                            onClick={() => handleRequestSort('vehicle_id')}
                                        >
                                            ID
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Name</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Type</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>Seats</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '10%' }}>Status</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Image</TableCell>
                                    <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>Action</TableCell>
                                    {vehicleSetEnabled ==1  &&<TableCell align="center" className="table-header" style={{ minWidth: '200px' }}>Attached Vehicle</TableCell>}
                                    {vehicleSetEnabled ==1  && <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>Vehicle Mapping</TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows
                                    .filter((row) => {
                                        const isStatusMatch = statusFilter 
                                            ? (statusFilter === 'Active' ? row.is_active === 1 : row.is_active === 0) 
                                            : true;
                                        // const isCityMatch = cityFilter ? row.city === cityFilter : true;
                                        const isVehicleTypeMatch = vehicleTypeFilter 
                                            ? getVehicleType(row.vehicle_type) === vehicleTypeFilter 
                                            : true;

                                        return isStatusMatch && isVehicleTypeMatch;
                                    })
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => (
                                        <TableRow key={row.vehicle_id}>
                                            <TableCell align="center">{row.vehicle_id}</TableCell>
                                            <TableCell align="center">{row.vehicle_name}</TableCell>
                                            <TableCell align="center">{getVehicleType(row.vehicle_type)}</TableCell>
                                            <TableCell align="center">{row.seat_count}</TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant="contained"
                                                    style={{
                                                        backgroundColor: row.is_active === 1 ? '#0DBA78' : '#D14545',
                                                        color: 'white',
                                                        textTransform: 'none',
                                                        pointerEvents: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '120px',
                                                    }}
                                                >
                                                    {row.is_active === 1 ? 'Active' : 'Inactive'}
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.vehicle_image ? (
                                                    <img
                                                        src={row.vehicle_image}
                                                        alt={row.vehicle_name}
                                                        height="75"
                                                        width="75"
                                                        style={{ borderRadius: '4px', objectFit: 'contain' }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            height: '75px',
                                                            width: '75px',
                                                            display: 'flex',
                                                            alignItems: 'center', 
                                                            justifyContent: 'center', // Horizontally center
                                                            marginLeft: '80px',
                                                            backgroundColor: '#f0f0f0',
                                                            color: '#9e9e9e',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            border: '1px solid #e0e0e0',
                                                        }}
                                                    >
                                                        No Image
                                                    </div>
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleViewDetails(row)}
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        border: '1px solid black',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        '&:hover': {
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                        },
                                                        '&:active': {
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                        },
                                                    }}
                                                >
                                                    View Details
                                                </Button>
                                            </TableCell>
                                                {vehicleSetEnabled == 1 && (
                                                <TableCell align="center">
                                                    <Box
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    gap={2}
                                                    justifyContent="center"   // horizontal center
                                                    alignItems="center"       // vertical center
                                                    textAlign="center"
                                                    width="100%"
                                                    >
                                                    {(() => {
                                                        const filtered =
                                                        rows?.filter(v =>
                                                            row?.vehicle_set?.includes(v.vehicle_id)
                                                        ) || [];

                                                        return filtered.length > 0 ? (
                                                        filtered.map(item => (
                                                            <Box
                                                            key={item.vehicle_id}
                                                            display="flex"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            sx={{
                                                                border: '1px solid #d9d4d4ff',
                                                                borderRadius: '20px',
                                                                padding: '6px 12px',
                                                                backgroundColor: '#f5f5f5'
                                                            }}
                                                            >
                                                            <Typography align="center">
                                                                {item.vehicle_name}
                                                            </Typography>
                                                            </Box>
                                                        ))
                                                        ) : (
                                                        "--"
                                                        );
                                                    })()}
                                                    </Box>
                                                </TableCell>
                                                )}
                                            {vehicleSetEnabled ==1 && <TableCell align="center">
                                               <Button
                                                variant="contained"
                                                onClick={() => {
                                                    setSelectedMapVehicle(row);
                                                    setOpenMapModal(true);
                                                    setSelectedMapVehicle(row);
                                                    setOpenMapModal(true);
                                                }}
                                                disabled={row.is_active === 0}
                                                sx={{
                                                    backgroundColor: 'white',
                                                    color: '#0DBA78',
                                                    border: row.is_active == 1 ? '1px solid #0DBA78' : '1px solid #d0ccccff',
                                                    textTransform: 'none',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        backgroundColor: '#0DBA78',
                                                        color: 'white',
                                                    },
                                                }}
                                            >
                                                Map Vehicle
                                            </Button>
                                            </TableCell>}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                        
                        {/* Pagination */}
                        <div className="custom-pagination">
                            <div className="pagination-info">
                                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                    (page + 1) * rowsPerPage,
                                    rows.length
                                )} of ${rows.length} entries`}
                            </div>
                            <div className="pagination-controls">
                            <button
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 0}
                                className="pagination-arrow"
                            >
                                <img src={prevIcon} alt="Previous" />
                            </button>
                                <div className="pagination-numbers">
                                    {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleChangePage(null, index)}
                                            className={`pagination-number ${
                                                page === index ? 'active' : ''
                                            }`}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}
                                </div>
                                <button
                                    onClick={() => handleChangePage(null, page + 1)}
                                    disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                    className="pagination-arrow"
                                >
                                    <img src={nextIcon} alt="Next" />
                                </button>
                            </div>
                        </div>
                    </TableContainer>
                
            {/* Right Sidebar */}
            {openAddVehicle && (
                <div className="add-vehicle-sidebar">
                    <div className="sidebar-overlay" onClick={handleCloseAddVehicle} />
                    <div className="sidebar-content">
                        <AddVehicle
                            onClose={handleCloseAddVehicle}
                            editMode={editMode}
                            vehicleData={selectedVehicle || {}}
                            vehicleCityId = {cityFilter}
                        />
                    </div>
                </div>
            )}

            <Dialog
                open={openMapModal}
                onClose={() => setOpenMapModal(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle
                    sx={{
                        position: 'relative',
                        textAlign: 'center',
                        fontWeight:400
                    }}
                >
                    Map Vehicles - {selectedMapVehicle?.vehicle_name} (<span style={{color: 'gray',fontSize: '12px'}}> Ride Type: {selectedMapVehicle?.ride_type == 1 ? "Normal" : selectedMapVehicle?.ride_type == 3 ? "Delivery" : selectedMapVehicle?.ride_type == 4 ? "Normal And Delivery" : "Shuttle"}</span>)

                    <Button
                        onClick={() => setOpenMapModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 12,
                            top: 12,
                            minWidth: 'auto',
                            padding: 0,
                            color: '#191919ff'
                        }}
                    >
                        <CancelIcon />
                    </Button>
                </DialogTitle>

                <DialogContent dividers>

                    {mapLoading ? (
                        <Box textAlign="center">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            {!selectedMapVehicle?.vehicle_set?.length ? (
                                    <Typography>No mapped vehicles</Typography>
                                ) : (
                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        gap={2}
                                    >
                                        {rows
                                            .filter(v =>
                                                selectedMapVehicle?.vehicle_set?.includes(v.vehicle_id)
                                            )
                                            .map((item) => (
                                                <Box
                                                    key={item.vehicle_id}
                                                    display="flex"
                                                    alignItems="center"
                                                    sx={{
                                                        border: '1px solid #d9d4d4ff',
                                                        borderRadius: '20px',
                                                        padding: '6px 12px',
                                                        backgroundColor: '#f5f5f5'
                                                    }}
                                                >
                                                    <Typography sx={{ marginRight: 1 }}>
                                                        {item.vehicle_name}
                                                    </Typography>

                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() =>
                                                            handleRemoveMapping(item.vehicle_id)
                                                        }
                                                    >
                                                        <CancelIcon fontSize="small"  />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                    </Box>
                                )}

                            {/* Add Section */}
                            <Box mt={3} display="flex" gap={2}>
                                <Select
                                    fullWidth
                                    value={selectedVehicleId}
                                    onChange={(e) =>
                                        setSelectedVehicleId(e.target.value)
                                    }
                                    displayEmpty
                                    sx={{width: '100%',height: '40px',borderRadius:"20px",border:"1px solid #d9d4d4ff"}}
                                >
                                    <MenuItem value="">
                                        Select Vehicle
                                    </MenuItem>

                                    {rows
                                    .filter((v) => {
                                        const currentRideType = selectedMapVehicle?.ride_type || null;

                                        return (
                                            v.is_active === 1 &&
                                            v.vehicle_id !== selectedMapVehicle?.vehicle_id &&
                                            !selectedMapVehicle?.vehicle_set?.includes(v.vehicle_id) &&
                                            rideTypeCompatibility[currentRideType]?.includes(v.ride_type)
                                        );
                                    })
                                    .map((v) => (
                                        <MenuItem key={v.vehicle_id} value={v.vehicle_id}>
                                            {v.vehicle_name || ""} {" "}  (<span style={{color: 'gray',fontSize: '12px'}}> Ride Type: {v.ride_type == 1 ? "Normal" : v.ride_type == 3 ? "Delivery" : v.ride_type == 4 ? "Normal And Delivery" : "Shuttle"}</span>)
                                        </MenuItem>
                                    ))}
                                </Select>

                                <Button
                                    variant="contained"
                                    onClick={handleAddMapping}
                                    sx={{backgroundColor: '#0165ff', color: '#fff',width: '40%',height: '40px',borderRadius:"20px"}}
                                >
                                    Add
                                </Button>
                            </Box>
                        </>
                    )}
                </DialogContent>
            </Dialog>

            <Dialog
                open={openSeatConfirmModal}
                onClose={() => handleSeatConfirm(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Seat Count Confirmation
                    <Button
                        onClick={() => handleSeatConfirm(false)}
                        sx={{
                            position: 'absolute',
                            right: 12,
                            top: 12,
                            minWidth: 'auto',
                            padding: 0,
                            color: '#191919ff'
                        }}
                    >
                        <CancelIcon />
                    </Button>
                </DialogTitle>
                
                <DialogContent>
                    <Typography sx={{ mb: 3, textAlign: 'center' }}>
                        {pendingSeatConfirm?.message}
                    </Typography>
                    
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <Button
                            onClick={() => handleSeatConfirm(false)}
                            variant="outlined"
                            sx={{ minWidth: '100px' }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => handleSeatConfirm(true)}
                            variant="contained"
                            sx={{ minWidth: '100px', backgroundColor: '#0DBA78' }}
                        >
                            Confirm
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Vehicles;